import React from 'react';
import { AlertTriangle, TrendingUp, AlertOctagon } from 'lucide-react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Alert, AlertDescription } from '../ui/alert';

dayjs.extend(relativeTime);

function TopRisks({ activities }) {
  const topRisks = activities
    .filter((a) => a.risk_score > 0)
    .sort((a, b) => b.risk_score - a.risk_score)
    .slice(0, 5);

  const getRiskIcon = (score) => {
    if (score >= 80) return <AlertOctagon className="h-4 w-4 text-destructive" />;
    if (score >= 50) return <AlertTriangle className="h-4 w-4 text-warning" />;
    return <TrendingUp className="h-4 w-4 text-primary" />;
  };

  const getRiskVariant = (score) => {
    if (score >= 80) return 'destructive';
    if (score >= 50) return 'warning';
    if (score >= 20) return 'default';
    return 'success';
  };

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base">Top Risks Today</CardTitle>
      </CardHeader>
      <CardContent>
        {topRisks.length === 0 ? (
          <Alert variant="success">
            <AlertDescription>No high-risk activities detected</AlertDescription>
          </Alert>
        ) : (
          <ul className="flex flex-col gap-2">
            {topRisks.map((risk, index) => (
              <li key={index} className="flex items-center gap-3">
                <div className="flex-shrink-0">{getRiskIcon(risk.risk_score)}</div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <p className="flex-1 truncate text-sm text-foreground">
                      {risk.description}
                    </p>
                    <Badge variant={getRiskVariant(risk.risk_score)}>{risk.risk_score}</Badge>
                  </div>
                  <p className="text-xs text-muted-foreground">
                    {dayjs(risk.timestamp).fromNow()}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}

export default TopRisks;
